// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".otp-input-wrapper[data-v-db9e217e]{display:-webkit-box;display:-ms-flexbox;display:flex}.otp-input-wrapper.disabled[data-v-db9e217e]{cursor:not-allowed;opacity:.5}.otp-input-wrapper .otp-input[data-v-db9e217e]:not(:first-child){margin-left:15px}", ""]);
// Exports
module.exports = exports;
